import axiosInstance from './AxiosInstance';

const API_URL = 'awardhistory';

export const getAwardhistory = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching awardhistory', error);
        throw error;
    }
};

export const approveAward = async (id, email) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/approveaward`, { id: id, email: email });
        return response.data;
    } catch (error) {
        console.error(`Error updating approve award with email ${email}`, error);
        throw error;
    }
};


export const awardhistoryByEmail = async (email) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/${email}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching awardhistory with email ${email}`, error);
        throw error;
    }
};


export const getAwardhistoryById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching awardhistory with id ${id}`, error);
        throw error;
    }
};

export const createAwardhistory = async (awardhistory) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, awardhistory);
        return response.data;
    } catch (error) {
        console.error('Error creating awardhistory', error);
        throw error;
    }
};

export const updateAwardhistory = async (id, awardhistory) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...awardhistory });
        return response.data;
    } catch (error) {
        console.error(`Error updating awardhistory with id ${id}`, error);
        throw error;
    }
};

export const deleteAwardhistory = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting awardhistory with id ${id}`, error);
        throw error;
    }
};

